import React, { useState, useCallback } from "react";
import EditorRemoveIcon from "@atlaskit/icon/glyph/editor/remove";
import { EMAIL_ADDRESS, PHONE_NUMBER } from "../../constants/general";
import { Modal } from "../Modal";
import { Link } from "../Link";
import { Button } from "../../UI/Button";
import { Typography } from "../../UI/Typography";
import { useModalContext } from "../../contexts/ModalContext/context";
import { Box } from "../../UI/Box";
import { useSnackbar } from "../../hooks/useSnackbar";

export interface IProps {
  data: any;
  onHide: any;
  onRemove: any;
}

export const QuestionRemovalModal: React.FC<IProps> = (props) => {
  const show = !!props.data && typeof props.data === "object";
  const { showErrorSnackbar } = useSnackbar();
  const [isLoading, setLoading] = useState(false);
  const { setIsOpen } = useModalContext();

  React.useEffect(() => {
    setIsOpen(show);
  }, [show]);

  const handleRemove = useCallback(async () => {
    setLoading(true);

    const success = await props.onRemove(props.data);

    if (success) {
      props.onHide();
    } else {
      showErrorSnackbar("An error occured. Please try again");
    }

    setLoading(false);
  }, [props.onRemove, !!props.data]);

  return (
    <Modal
      title="Confirm Question Deletion"
      actions={
        <>
          <Button appearance="subtle" onClick={() => props.onHide(null)}>
            Cancel
          </Button>
          <Button
            appearance="danger"
            onClick={handleRemove}
            isLoading={isLoading}
            iconAfter={<EditorRemoveIcon label="Delete" />}
          >
            Delete Question
          </Button>
        </>
      }
    >
      <Box px={3} py={2}>
        <Typography variant="body2" gutterBottom>
          You are about to delete a lifestyle question. All answers already // submitted by users for this question will
          be deleted as well.
        </Typography>
        <Typography variant="body2" gutterBottom>
          If you have questions about how clears work, please call us at {PHONE_NUMBER} or e-mail{" "}
          <Link href={`mailto:${EMAIL_ADDRESS}`}>{EMAIL_ADDRESS}</Link>
        </Typography>
      </Box>
    </Modal>
  );
};
